import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface AboutCompany {
  id: number;
  title: string;
  description: string;
  order: number;
  file_id: number;
  link: string;
  created_at: string;
  updated_at: string;
  file: {
    data:
      | {
          id: number;
          title: string;
          type: string;
          ext: string;
          description: null | string;
          url: string;
          alt: null | string;
          caption: null | string;
          created_at: string;
          updated_at: string;
        }
      | [];
  };
}

export interface AboutCompanies {
  data: AboutCompany[];
  meta: {
    pagination: {
      total: number;
      count: number;
      per_page: number;
      current_page: number;
      total_pages: number;
      links: object;
    };
  };
}

export class AboutCompanyRepository extends BaseRepository<AboutCompany> {
  collection = "about-companies";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  getMany(
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<AboutCompany[]>> {
    return super.getMany(queryParams);
  }
}
